import api from "api";
import { AppAction, AppButton, AppGridLayout, AppRow, AppTable } from 'qcc';
import React from 'react';
import SetBillTemplateForm from './SetBillTemplateForm';
import SyncError from './SyncError';

let refAppGridLayout = null as AppGridLayout;


export const pageAction = {
  setRefGrid: (appGridLayout: AppGridLayout) => {
    refAppGridLayout = appGridLayout;
  },

  // 生成单据
  generateBill: async () => {
    if (refAppGridLayout.state && refAppGridLayout.state.refTable) {
      let itemList = refAppGridLayout.state.refTable.getSelected();
      if (itemList.length === 0) {
        AppAction.alert('请选择需要生成的款项明细!');
        return;
      }

      // 校验选择的客户，或则房间 是不是同一个
      let errMsg = '';
      let data = itemList[0];
      let { erp_customer_id, room_info } = data;
      itemList.map((i: any) => {
        if (i.room_info !== room_info) {
          errMsg = "请选择同一个房间下的款项！";
        }
      })

      if (errMsg !== '') {
        AppAction.alert(errMsg);
        return;
      }

      // 打开选择模板界面
      let projectId = itemList[0].project_id;
      let templateOptionList = await api.wisdomcashiertemplate.getTemplateOptions({ projectId })
      let getInFeeIdList = itemList.map((item: any) => {
        return item.id as number;
      })
      let formData = { ...data, templateOptionList, getInFeeIdList }

      let title = '选择票据模板';
      let width = 460;
      let height = 360
      let editForm = <SetBillTemplateForm mode={1} formData={formData} afterSave={fetchTable} />
      AppAction.openDialog(editForm, { title, width, height });
    }
  }
}

const syncGetin = async (data?: any) => {
  // 先遮罩层
  AppAction.coverFull();
  await api.posapp.getCreatestk({ "getInId": data.get_in_id, "type": "1" }).then(res => {
    if (res.result) {
      AppAction.successMsg('操作成功！')
    } else {
      AppAction.errorMsg(res && res.msg || "操作失败，请稍后重试！")
    }
  }).catch(err => {
    // AppAction.errorMsg(err && err.msg || "操作失败，请稍后重试！")
    let title = '操作失败';
    let width = 600;
    let height = 200;
    let syncError = <SyncError />
    AppAction.openDialog(syncError, {
      title, height, width
    });
  });
  fetchTable();
  AppAction.cancelCoverFull();

}

const syncCancelGetin = async (data?: any) => {
  // 先遮罩层
  AppAction.coverFull();
  await api.posapp.getReversestkState({ "getInId": data.get_in_id }).catch(err => {
    AppAction.errorMsg(err && err.msg || "操作失败，请稍后重试！")
  });
  fetchTable();
  AppAction.cancelCoverFull();

}

const fetchTable = () => {
  refAppGridLayout.state && refAppGridLayout.state.refTable.fetch()
}

const openBill = async (data?: any) => {
  let { voucher_id } = data;
  let key = await api.public.getBillUrlKey({ id: voucher_id });
  window.open(`/pos/voucher/${voucher_id}?key=${key}`);
}

const getCreatereceipt = async (data?: any) => {
  AppAction.coverFull();
  await api.posapp.getCreatereceipt({ "voucherId": data.voucher_id }).then(res => {
    if (res.result) {
      AppAction.successMsg('操作成功！')
    } else {
      AppAction.errorMsg(res && res.msg || "操作失败，请稍后重试！")
    }
  }).catch(err => {
    AppAction.errorMsg(err && err.msg || "操作失败，请稍后重试！")
  });
  fetchTable();
  AppAction.cancelCoverFull();
}
export const PageOptions = {
  SyncStatus: [
    { label: '未同步', value: '未同步' },
    { label: '已同步', value: '已同步' },
  ],

  WebBillStatus: [
    { label: '未生成', value: '未生成' },
    { label: '未同步', value: '未同步' },
    { label: '已同步', value: '已同步' },
  ],

  Scene: {
    slk: '收楼款',
    sdsf: '收代收费',
    sbck: '收补差款',
    scj: '收筹金',
    szsk: '收暂收款',
    ssxf: '收手续费'
  }
}

const renderScene = (data?: any, dataIndex?: number) => {
  return PageOptions.Scene[data.scene] || '';
}

const renderBill = (data?: any, dataIndex?: number) => {
  let { web_bill_status_name, voucher_bill_no } = data;
  if (web_bill_status_name === '未生成') {
    return '未生成'
  } else if (web_bill_status_name === '未同步') {
    return <AppRow itemSplit={10}>
      <span className='page-pos-getin-grid-link' onClick={() => openBill(data)}>{voucher_bill_no}</span>
      <span className='page-pos-getin-grid-link' onClick={() => getCreatereceipt(data)}>同步</span>
    </AppRow>
  } else {
    return <span className='page-pos-getin-grid-link' onClick={() => openBill(data)}>{voucher_bill_no}</span>
  }
}



const getinGrid = (
  <AppTable paging sqlId='sql.pos.getInDtlGrid' orderBy='get_date desc,id' onBeforeApi={(data: any) => { return data.projectId !== undefined }}>
    <AppTable.ColCheckbox width={30} />
    <AppTable.ColIndex width={30} />
    <AppTable.Col title='付款人' field="customer_name" width={80} align={"center"} />
    <AppTable.Col title='房间' field='room_info' width={500} />
    {/* <AppTable.Col title='证件号' field="id_number" width={200} />
    <AppTable.Col title='手机号' field="tell" width={120} /> */}
    <AppTable.Col title='收款人' field="skr" width={80} align={"center"} />
    <AppTable.ColDateTime title='收款时间' field="get_date" width={150} />
    {/* <AppTable.Col title='收款单号' field="bill_no" width={180} /> */}
    {/* <AppTable.Col title='POS单号' field="pos_code" width={150}/> */}
    <AppTable.Col title='POS流水号' field="ref_no" width={120} />
    <AppTable.Col title='SAP实收单号' field="sap_code" width={125} />
    <AppTable.ColMoney title='单据总额' field="total_amount" width={150} />
    <AppTable.Col title='款项名称' field="fund_name" width={120} />
    <AppTable.ColMoney title='款项金额' field="amount" width={100} />
    <AppTable.Col title='手续费（T+1）' field="sxf" width={100} />
    <AppTable.Col title='结算账号' field="bank_number" width={200} />
    <AppTable.Col title='结算账户名称' field="bank_name" width={200} />
    <AppTable.Col title='购房人' field="buyer_name" width={100} />
    <AppTable.Col title='监管账号' field="regulatory_account" width={200} />
    <AppTable.Col title='监管子账号' field="sub_regulatory_account" width={200} />
    <AppTable.Col title='住建局缴费单号' field="zjj_bill_no" width={200} />
    <AppTable.Col title='缴费备注' field="zjj_remark" width={200} />
    <AppTable.ColDateTime title='电子收据' render={(data?: any, dataIndex?: number) => { return renderBill(data, dataIndex) }} width={210} />
    <AppTable.Col title='电子收据同步异常消息' field='web_bill_error_msg' width={180} align={"left"} />
    <AppTable.Col title='推送sap' field='sync_status_name' width={80} align={"center"} />
    <AppTable.Col title='sap同步异常消息' field='pos_getin_error_msg' width={180} align={"left"} />
    <AppTable.ColAction width={100} align={"center"} render={(data?: any, dataIndex?: number) => {
      return data.sync_status_name === '未同步' ? <AppButton label='同步款项' actionCode="66101002" type='link' action={() => syncGetin(data)} /> : null
    }}
    />
  </AppTable>)



const getinCacelGrid = (
  <AppTable paging sqlId='sql.pos.getInDtlCancelGrid' leftFixIndex={1} rightFixIndex={14} orderBy='get_date desc,id' onBeforeApi={(data: any) => { return data.projectId !== undefined }}>
    <AppTable.ColIndex width={30} />
    <AppTable.Col title='付款人' field="customer_name" width={80} align={"center"} />
    <AppTable.Col title='房间' field='room_info' width={500} />
    {/* <AppTable.Col title='证件号' field="id_number" width={120} />
    <AppTable.Col title='手机号' field="tell" width={120} /> */}
    <AppTable.Col title='收款人' field="skr" width={80} align={"center"} />
    <AppTable.Col title='退款人' field="tkr" width={80} />
    <AppTable.ColDateTime title='收款时间' field="get_date" width={150} />
    <AppTable.ColDateTime title='退款时间' field="tk_date" width={150} />
    {/* <AppTable.Col title='收款单号' field="bill_no" width={180} /> */}
    {/* <AppTable.Col title='POS单号' field="pos_code" width={150}/> */}
    <AppTable.Col title='POS流水号' field="ref_no" width={120} />
    <AppTable.Col title='SAP实收单号' field="sap_code" width={125} />
    <AppTable.ColMoney title='单据总额' field="total_amount" width={150} />
    <AppTable.Col title='款项名称' field="fund_name" width={120} />
    <AppTable.ColMoney title='款项金额' field="amount" width={100} />
    <AppTable.Col title='手续费（T+1）' field="sxf" width={100} />
    <AppTable.Col title='结算账号' field="bank_number" width={200} />
    <AppTable.Col title='结算账户名称' field="bank_name" width={200} />
    <AppTable.ColDateTime title='电子收据' render={(data?: any, dataIndex?: number) => { return renderBill(data, dataIndex) }} width={210} />
    <AppTable.Col title='电子收据同步异常消息' field='web_bill_error_msg' width={180} align={"left"} />
    <AppTable.Col title='推送sap' field='sync_cancel_status_name' width={80} align={"center"} />
    <AppTable.Col title='推送sap同步异常消息' field='pos_getin_error_msg' width={180} align={"left"} />
    <AppTable.ColAction width={100} align={"center"} render={(data?: any, dataIndex?: number) => {
      return data.sync_cancel_status_name === '未同步' ? <AppButton label='同步款项' actionCode="66101002" type='link' action={() => syncCancelGetin(data)} /> : null
    }}
    />

  </AppTable>)

export const indexTable = [getinGrid, getinCacelGrid];



// WEBPACK FOOTER //
// ./src/page/pos/getin/indexData.tsx